import { useMutation } from '@apollo/react-hooks';
import { useCallback } from 'react';
import { useCountry } from '../../../components/CountrySelector';
import { useCart } from '../useCart';
import {
  UpdateCartMutationVariables,
  UpdateCartMutation,
  UPDATE_CART_MUTATION,
  UpdateCartMutationAttributes,
  CartUpdateAction
} from './useUpdateCartMutation.rest';

export const useUpdateCartMutation = () => {
  const countryCode = useCountry().country.alpha2Code;
  const { cart } = useCart();

  const [mutate, { data, loading, error }] = useMutation<
    UpdateCartMutation,
    UpdateCartMutationVariables
  >(UPDATE_CART_MUTATION);

  const updateCart = useCallback(
    async (actionType: CartUpdateAction, attributes: UpdateCartMutationAttributes) => {
      const cartId = attributes.id || cart.id;

      if (!cartId) return Promise.reject('updateCartMutation: cart not found');

      return await mutate({
        variables: {
          id: cartId,
          countryCode,
          target: cart.attributes.version,
          input: {
            data: {
              // eslint-disable-next-line @typescript-eslint/camelcase
              action_type: actionType,
              attributes,
              id: cartId,
              type: 'carts'
            }
          }
        }
      });
    },
    [cart.attributes.version, cart.id, countryCode, mutate]
  );

  return [updateCart, { data, loading, error }] as const;
};
